import Detail1 from 'images/games/solitaire-venture/detail1.png'
import Detail2 from 'images/games/solitaire-venture/detail2.png'
import Detail3 from 'images/games/solitaire-venture/detail3.png'
import Footer from 'images/games/solitaire-venture/footer.png'
import Icon from 'images/games/solitaire-venture/icon.png'
import Swiper1 from 'images/games/solitaire-venture/swiper1.webp'
import Swiper2 from 'images/games/solitaire-venture/swiper2.webp'
import Swiper3 from 'images/games/solitaire-venture/swiper3.webp'
import Swiper4 from 'images/games/solitaire-venture/swiper4.webp'
import Swiper5 from 'images/games/solitaire-venture/swiper5.webp'
import Swiper6 from 'images/games/solitaire-venture/swiper6.webp'
import { GamesLink, SolitaireClashLink, SolitaireInfiniteLink, SolitaireSlamLink, TextLink } from '../../components'
import { SolitaireVentureEntity } from './entity'
import { TemplatePageProps } from './types'

export const SolitaireVentureDetail: TemplatePageProps = {
  entity: {
    ...SolitaireVentureEntity,
    logo: Icon,
    title: (
      <>
        Solitaire Venture: Play Online <strong>Solitaire for Cash</strong>
      </>
    ),
    description: (
      <>
        Discover Solitaire Venture, a fresh take on the <strong>classic Solitaire card game</strong>! Join your fox
        companion to build an island empire, uncover treasures, and play <strong>solitaire for cash</strong> in free
        trial matches, or choose cash matches for even more rewards! Build your empire with every victory. Download now
        for an exciting adventure!
      </>
    ),
  },
  swiper: [
    { image: Swiper1 },
    { image: Swiper2 },
    { image: Swiper3 },
    { image: Swiper4 },
    { image: Swiper5 },
    { image: Swiper6 },
  ],
  content: [
    {
      title: (
        <>
          <strong>Timeless Solitaire Meets Island Adventure</strong>
        </>
      ),
      description: (
        <>
          Build your empire across stunning, ever-changing island themes! Use strategy to draw, flip, and stack cards in
          the Tableau and Foundation piles. Explore three dynamic match modes: uncover cash bonuses in Treasure Mode,
          earn prizes by shaping your dream island in Build Mode, or engage in strategic battles in Attack Mode! Perfect
          for casual fun or competitive play, so download now and turn every <strong>solitaire game</strong> into an
          adventure!
        </>
      ),
      image: Detail1,
    },
    {
      title: (
        <>
          Real Cash Events in <strong>Solitaire Online</strong>
        </>
      ),
      description: (
        <>
          <strong>Solitaire Venture</strong> takes the <strong>classic solitaire</strong> card game to the next level,
          turning it into a fast-paced, skill-based competition where real money is on the line! Players can duel it out
          one-on-one or join Multiplayer Matches with 4–10 opponents, putting their strategy and speed to the test.
          Enter thrilling modes like Dragon Eggstravaganza, complete in-game tasks to boost your earnings, and unlock
          bonus rewards with the exclusive Venture Pass! Whether you&#39;re playing casually or aiming for the top of
          the leaderboard, every match delivers a competitive edge and the opportunity to win real cash prizes.
        </>
      ),
      image: Detail2,
    },
    {
      title: 'Safe Matches, Trusted Payments, and Reliable Player Support',
      description: (
        <>
          We’re committed to your safety and satisfaction. Play worry-free with strong data encryption and privacy
          protection. Cash out fast with <strong>PayPal</strong> and deposit easily using trusted services like{' '}
          <strong>Venmo</strong>, <strong>Apple Pay</strong>, <strong>Visa</strong>, <strong>Mastercard</strong>, and{' '}
          <strong>Discover</strong>.
          <br />
          <br />
          <strong>Avia</strong> offers dedicated player support to ensure every user&#39;s smooth and enjoyable
          experience. Our customer service team is ready to assist you with questions about your account, payments,
          gameplay, or anything else. Contact{' '}
          <TextLink href="/support" strong>
            player support
          </TextLink>{' '}
          anytime for personalized assistance.
        </>
      ),
      image: Detail3,
    },
    {
      title: 'Ready to Play and Win? ',
      description: (
        <>
          Whether you’re mastering strategy in klondike solitaire, building your dream island empire, or climbing the
          leaderboard in real cash tournaments, <strong>Solitaire Venture</strong> delivers nonstop fun and competitive
          excitement. With multiple game modes, beautiful islands, and the opportunity to{' '}
          <strong>win real rewards</strong>, there’s something for every type of player.
          <br />
          <br />
          Looking for more ways to play and win? Explore Avia&#39;s other exciting <strong>card games</strong>, like{' '}
          <SolitaireClashLink strong />, <SolitaireInfiniteLink strong />, and <SolitaireSlamLink strong />, which offer{' '}
          <GamesLink strong>real money game</GamesLink> competitions and casual fun, perfect for both quick breaks and
          longer play sessions!
        </>
      ),
    },
  ],
  footer: {
    image: Footer,
  },
}
